import { Col, Row } from 'components/Grid';
import { appSettings } from 'config/app.settings';
import React from 'react';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';

import * as S from './page-header.styles';

interface IParent {
  to: string;
  label: string;
}

interface IPageHeaderProps {
  pageTitle?: string;
  appBanner?: boolean | string;
  title?: string;
  parents?: IParent[];
  children?: React.ReactNode;
  className?: string;
  hasTabs?: boolean;
}

export const PageHeader = ({
  className,
  title,
  children,
  parents,
  hasTabs,
  pageTitle,
  appBanner,
}: IPageHeaderProps) => {
  const appArgument = typeof appBanner === 'string' ? appBanner : 'dashboard';

  return (
    <S.PageHeader className={className} hasTabs={!!hasTabs}>
      <Helmet>
        <title>{pageTitle || title}</title>
        {appBanner && (
          <meta
            name="apple-itunes-app"
            content={`app-id=${appSettings.APP_ID}, app-argument=myvfnl://${appArgument}`}
          />
        )}
      </Helmet>

      <S.Wrapper>
        <Row noMargin>
          <Col>
            <S.PageTitle>
              {parents && (
                <S.BreadCrumbs>
                  {parents.map((parent, index: number) => (
                    <React.Fragment key={index}>
                      <NavLink to={parent.to}>{parent.label}</NavLink> /{' '}
                    </React.Fragment>
                  ))}
                </S.BreadCrumbs>
              )}
              {title && <S.Title data-testid="page-header-title">{title}</S.Title>}
            </S.PageTitle>
          </Col>
        </Row>
        <div>{children}</div>
      </S.Wrapper>
    </S.PageHeader>
  );
};
